import { render } from "./OtherCompanies.vue?vue&type=template&id=1f031f72&scoped=true"
import script from "./OtherCompanies.vue?vue&type=script&lang=js"
export * from "./OtherCompanies.vue?vue&type=script&lang=js"

import "./OtherCompanies.vue?vue&type=style&index=0&id=1f031f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f031f72"]])

export default __exports__